import React from 'react';
import { FaTrash, FaCodeBranch } from 'react-icons/fa';
import './ActionButtons.scss';

interface ActionButtonsProps {
  quantity: number;
  onSplit?: () => void;
  onDelete: () => void;
  allowEdit: boolean; // New prop to control edit permissions
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  quantity,
  onSplit,
  onDelete,
  allowEdit
}) => {
  return (
    <div className="action-buttons">
      {quantity > 1 && (
        <button
          className="action-button split-button"
          onClick={onSplit}
          aria-label="Separar selección"
          title="Separar en nueva línea"
        >
          <FaCodeBranch />
        </button>
      )}
      {allowEdit &&
      <button
        className="action-button delete-button"
        onClick={onDelete}
        aria-label="Eliminar selección"
        title="Eliminar selección"
      >
        <FaTrash />
      </button>
      }
    </div>
  );
};

export default ActionButtons;
